// Russian (`ru`) shell baseline
import { layoutRu } from './ru/layout'
import { homeRu } from './ru/home'
import { playRu } from './ru/play'
import { demoRu } from './ru/demo'
import { booksRu } from './ru/books'
import { commerceRu } from './ru/commerce'
import { communityRu } from './ru/community'
import { dashboardRu } from './ru/dashboard'
import { authRu } from './ru/auth'
import { marketingRu } from './ru/marketing'
import { worldRu } from './ru/world'
import { encyclopediaRu } from './ru/encyclopedia'
import { systemRu } from './ru/system'
import { cityRu } from './ru/city'
import type { MessageCatalog } from '@gamecodex/world-config'

export const baseRu: MessageCatalog = {
  ...layoutRu,
  ...homeRu,
  ...playRu,
  ...demoRu,
  ...booksRu,
  ...commerceRu,
  ...communityRu,
  ...dashboardRu,
  ...authRu,
  ...marketingRu,
  ...worldRu,
  ...encyclopediaRu,
  ...systemRu,
  ...cityRu,
}
